/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInVersion: core.serialization.ObjectSchema<serializers.NotInVersion.Raw, Truvity.NotInVersion> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.number()),
    });

export declare namespace NotInVersion {
    export interface Raw {
        values: number[];
    }
}
